import type { SVGProps } from "react";

type LogoProps = Omit<SVGProps<SVGSVGElement>, "children"> & {
  size?: number | string;
};

/**
 * Google G 로고 (4색 공식 에셋).
 * 출처: https://developers.google.com/identity/branding-guidelines
 */
export function GoogleLogo({ size = 20, ...rest }: LogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width={size}
      height={size}
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      <path
        fill="#EA4335"
        d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
      />
      <path
        fill="#4285F4"
        d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
      />
      <path
        fill="#FBBC05"
        d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
      />
      <path
        fill="#34A853"
        d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
      />
    </svg>
  );
}

/**
 * Kakao 말풍선 로고.
 * 출처: https://developers.kakao.com/docs/latest/ko/reference/design-guide (공식 심볼)
 */
export function KakaoLogo({ size = 20, ...rest }: LogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      width={size}
      height={size}
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      <path
        fill="currentColor"
        d="M128 36C70.562 36 24 72.654 24 117.84c0 29.184 19.296 54.747 48.49 69.276l-9.79 35.73c-.89 3.245 2.78 5.851 5.653 4.013l42.967-28.292c5.453.625 10.957.954 16.68.954 57.438 0 104-36.654 104-81.681S185.438 36 128 36z"
      />
    </svg>
  );
}

export function NaverLogo({ size = 20, ...rest }: LogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      <path
        fill="currentColor"
        d="M4 4h5.35l5.3 7.66V4H20v16h-5.35l-5.3-7.66V20H4V4z"
      />
    </svg>
  );
}

export function AppleLogo({ size = 20, ...rest }: LogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      <path
        fill="currentColor"
        d="M16.42 12.42c-.02-2.26 1.85-3.35 1.93-3.4-1.05-1.54-2.68-1.75-3.25-1.77-1.38-.14-2.7.81-3.4.81-.7 0-1.79-.79-2.94-.76-1.51.02-2.9.88-3.68 2.23-1.57 2.73-.4 6.78 1.13 8.99.75 1.08 1.64 2.3 2.82 2.25 1.13-.04 1.56-.73 2.93-.73s1.75.73 2.95.7c1.22-.02 1.99-1.1 2.73-2.19.86-1.26 1.22-2.48 1.24-2.54-.03-.01-2.44-.94-2.46-3.59zM14.2 5.8c.62-.75 1.04-1.79.92-2.83-.9.04-1.99.6-2.63 1.35-.58.67-1.08 1.74-.94 2.76 1 .08 2.03-.51 2.65-1.28z"
      />
    </svg>
  );
}
